<template>
  <v-app>
    <v-main>
      <v-container v-if="$auth.error">
        <v-alert type="error" role="alert">{{ $auth.error }}</v-alert>
        <v-btn @click="retry">Try again</v-btn>
      </v-container>
      <router-view v-else-if="$auth.isAuthenticated"></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  methods: {
    retry() {
      window.location.reload();
    },
  },
};
</script>
